<aura-dialog-layout [title]="'Publication de votre annonce'" [hideCancel]="true">
  <div dialog-content class="flex flex-col gap-4 py-2">
    <!-- Notice 1: Mandate lock warning (Ferme & Explicite) -->
    <div class="flex items-start gap-3.5 rounded-xl border border-amber-6 bg-amber-2/60 p-4">
      <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-3 text-amber-11">
        <mat-icon svgIcon="lock" />
      </div>
      <div class="flex-1">
        <h3 class="font-bold text-amber-12 m-0">Conditions de mandat définitivement verrouillées</h3>
        <p class="mt-1.5 text-sm text-amber-11 leading-relaxed m-0">
          Dès que vous publiez votre annonce, <strong>l'ensemble des conditions de mandat</strong> (type de
          mandat autorisé, pourcentage d'honoraires, durée, conditions particulières)
          <strong>ne pourront plus être modifiées</strong>.
        </p>
        <p class="mt-1.5 text-sm text-amber-12 font-medium leading-relaxed m-0">
          ⚠️ Assurez-vous d'avoir bien relu et validé vos conditions de mandat avant de confirmer la première
          publication.
        </p>
      </div>
    </div>

    <!-- Notice 2: Value of a fully completed listing (Impact & Juste Prix) -->
    <div class="flex items-start gap-3.5 rounded-xl border border-indigo-6 bg-indigo-2/50 p-4">
      <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-indigo-3 text-indigo-11">
        <mat-icon svgIcon="sparkles" />
      </div>
      <div class="flex-1">
        <h3 class="font-bold text-indigo-12 m-0">Une annonce complète maximise vos chances de vente</h3>
        <p class="mt-1.5 text-sm text-indigo-11 leading-relaxed m-0">
          Une annonce complétée avec soin (photos de qualité, diagnostics DPE renseignés, caractéristiques
          précises et charges détaillées) attire
          <strong>naturellement plus d'acquéreurs qualifiés et les meilleurs agents immobiliers</strong> de
          votre secteur, tout en permettant de valoriser votre bien à un
          <strong>tarif de vente plus juste</strong>.
        </p>
        <p class="mt-2 text-sm text-indigo-12 font-medium leading-relaxed m-0">
          Dès la mise en ligne, votre annonce devient visible de tous les agents immobiliers partenaires de
          votre secteur qui peuvent alors se positionner pour candidater. Veillez à n'activer votre bien que
          lorsque vous êtes prêt à organiser les visites et à entamer la vente.
        </p>
      </div>
    </div>

    <!-- Confirmation Checkbox -->
    <div class="pt-2 px-1">
      <mat-checkbox [checked]="confirmed()" (change)="confirmed.set($event.checked)" class="text-xs">
        <span class="text-sm font-semibold text-gray-12 leading-tight">
          J'ai vérifié l'exactitude de mon annonce et je confirme les conditions de mon mandat.
        </span>
      </mat-checkbox>
    </div>
  </div>

  <div
    dialog-actions
    class="flex flex-col-reverse sm:flex-row items-stretch sm:items-center justify-end gap-3 w-full pt-2"
  >
    <button
      mat-stroked-button
      type="button"
      (click)="onCancel()"
      class="flex-1 sm:flex-initial text-sm font-semibold"
    >
      <span>Vérifier mon annonce d'abord</span>
    </button>

    <button
      mat-flat-button
      class="primary flex-1 sm:flex-initial flex items-center justify-center gap-1.5 text-sm font-semibold"
      type="button"
      [disabled]="!confirmed()"
      (click)="onConfirm()"
    >
      <mat-icon class="text-sm! w-4! h-4!" svgIcon="rocket" />
      <span>Confirmer & Publier</span>
    </button>
  </div>
</aura-dialog-layout>
